export default __webpack_public_path__ + "static/media/37.583006d7.jpeg";